var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({
    el: 'html',
    easing: 'ease-in-out',
    duration: 600
  }),expression:"{\n    el: 'html',\n    easing: 'ease-in-out',\n    duration: 600\n  }"},{name:"scroll-class",rawName:"v-scroll-class:is-shown",value:(645),expression:"645",arg:"is-shown"}],ref:"scrollToTop",staticClass:"button scroll-to-top print:hidden"},[_c('Icon',{staticClass:"w-6 h-6",attrs:{"name":"chevron-up"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }